import React, { createContext, useContext, useEffect, useState } from "react";
import { useMatches, UIMatch } from "react-router-dom";
import { RouteHandle } from "@/routes";

interface FilterEnabledContextType {
  isEnabled: boolean;
}

const FilterEnabledContext = createContext<FilterEnabledContextType | null>(
  null,
);

export function FilterEnabledProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isEnabled, setIsEnabled] = useState(false);

  const routeMatches = useMatches() as UIMatch<
    undefined,
    RouteHandle | undefined
  >[];

  const currentMatch = routeMatches[routeMatches.length - 1];
  const filtersAllowed = !!currentMatch.handle?.allowFilters;

  useEffect(() => {
    setIsEnabled(filtersAllowed);
  }, [filtersAllowed]);

  return (
    <FilterEnabledContext.Provider value={{ isEnabled }}>
      {children}
    </FilterEnabledContext.Provider>
  );
}

export function useFilterEnabled() {
  const context = useContext(FilterEnabledContext);
  if (!context) {
    return {
      isEnabled: false,
    };
  }
  return context;
}
